require('./bootstrap');

import VueScrollTo from 'vue-scrollto';

import { createApp } from 'vue';
// import HelloWorld from './components/HelloWorld.vue';
import VerifyIdForm from './components/verify/VerifyIdForm.vue';

const app = createApp({});
    app
    .component('verify-id-form', VerifyIdForm)
    .mount('#app');

// Add Vue directive
app.directive('scroll-to', VueScrollTo);